import { z } from "zod";

import { branded } from "@/lib/helpers/branded-helper";
import { appointmentStateDtoSchema } from "@/types/backoffice/dto/appointment/appointment-state-dto.ts";
import { appointmentTypeSchema } from "@/types/backoffice/dto/appointment/appointment-type-dto.ts";
import { serviceProviderDtoSchema } from "@/types/backoffice/dto/appointment/service-provider-dto.ts";

export const appointmentDtoSchema = z.object({
  comment: z.string().nullable(),
  creationDate: z.coerce.date(),
  creationPersonFirstName: z.string(),
  creationPersonLastName: z.string(),
  flexible: z.boolean(),
  id: z.number(),
  isCompromised: z.boolean(),
  isExternalAppointment: z.boolean(),
  localEndDate: branded.localeDateTime,
  localStartDate: branded.localeDateTime,
  appointmentConfirmedAt: z.coerce.date().nullable(),
  serviceProvider: serviceProviderDtoSchema,
  state: appointmentStateDtoSchema,
  type: appointmentTypeSchema,
});

export type TAppointmentDto = z.infer<typeof appointmentDtoSchema>;
